// extracted by mini-css-extract-plugin
export default {"wrapper":"Response-module__wrapper___55UHi","message":"Response-module__message___wkgQB"};